import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
    name: 'DeliveryCard',
    props: {
        type: {
            type: String,
            required: true
        },
        svgIcon: {
            type: String,
            required: true
        },
        isShippingFree: {
            type: Boolean,
            required: false
        }
    },
    setup(props) {
        const store = useStore()

        const activeDeliveryType = computed(
            () => store.state.checkout.stepTwo.activeDeliveryType
        )

        let isChosenDelivery = computed(() => {
            if (activeDeliveryType.value) {
                return props.type === activeDeliveryType.value ? true : false
            } else {
                return false
            }
        })

        const totals = computed(() => store.state.basket.totals)

        const isShippingFree = computed(
            () => totals.value?.isShippingFree ?? false
        )

        const invoiceAddress = computed(() => {
            return store.state.checkout.purchaseData.invoice.invoiceAddress
        })

        const determineLabelCollection = function () {
            switch (props.type) {
                case 'home':
                    return 'deliveryCardHome'
                case 'pickUp':
                    return 'deliveryCardPickUp'
                default:
                    console.error(
                        'search boolean or type missing in order to determine labelCollection'
                    )
            }
        }

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: determineLabelCollection(),
                labelKey: labelKey
            })

        const updateActiveDeliveryType = function (payload) {
            store.commit('checkout/set_active_delivery_type', payload)
            if (activeDeliveryType != payload)
                store.dispatch('basket/updateActiveDeliveryType', payload)
        }

        const showDifferentAddress = computed(
            () => store.state.checkout.stepTwo.showDifferentAddress
        )
        const updateShowDifferentAddress = function (payload) {
            store.commit('checkout/set_show_different_address', payload)
        }

        const updateShowPickUpAddresses = function (payload) {
            store.commit('checkout/set_show_pick_up_addresses', payload)
        }

        const handleShowDifferentAddress = function () {
            if (showDifferentAddress.value === false) {
                updateShowDifferentAddress(true)
                updateActiveDeliveryType(props.type)
                updateShowPickUpAddresses(false)
            } else {
                // set delivery data validation to true when different address NOT chosen
                store.commit(
                    'checkout/set_delivery_data_validation_success',
                    true
                )
                updateShowDifferentAddress(false)
                updateShowPickUpAddresses(false)
                updateActiveDeliveryType(props.type)
            }
        }

        const handleChosenDelivery = function () {
            updateActiveDeliveryType(props.type)

            // set active delivery address as default to invoice address
            store.commit(
                'checkout/set_active_delivery_address',
                store.state.checkout.purchaseData.invoice.invoiceAddress
            )

            if (isChosenDelivery.value === true) {
                switch (props.type) {
                    case 'home':
                        updateShowPickUpAddresses(false)
                        updateShowDifferentAddress(false)
                        // set delivery data validation to false when default address chosen
                        store.commit(
                            'checkout/set_delivery_data_validation_success',
                            true
                        )
                        break
                    case 'pickUp':
                        updateShowDifferentAddress(false)
                        updateShowPickUpAddresses(true)
                        // set delivery data validation to false when different than default address chosen
                        store.commit(
                            'checkout/set_delivery_data_validation_success',
                            false
                        )
                        break
                    default:
                        updateShowDifferentAddress(false)
                        updateShowPickUpAddresses(false)
                        // set delivery data validation to true when default address chosen
                        store.commit(
                            'checkout/set_delivery_data_validation_success',
                            true
                        )
                }
            }
        }

        return {
            getLabel,
            showDifferentAddress,
            handleShowDifferentAddress,
            handleChosenDelivery,
            isChosenDelivery,
            invoiceAddress,
            asideResults: totals,
            isShippingFree
        }
    }
}
